var classof = require('../internals/classof');
var uncurryThis = require('../internals/function-uncurry-this');

var slice = uncurryThis(''.slice);

module.exports = function (it) {
  return slice(classof(it), 0, 3) === 'Big';
};



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/internals/is-big-int-array.js
// module id = 9RjV
// module chunks = 04af